import { newFormOpeningTime } from 'src/helpers/venueFormUtilities/constants';
import { IOpeningTime } from '../../types';

export const createNewFormOpeningTime = (): IOpeningTime => {
  // this is needed to work around the default safari time input value clashing with validation
  if (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')) {
    return {
      ...newFormOpeningTime,
      start: '12:30',
      end: '12:30',
    };
  }
  return newFormOpeningTime;
};
